"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mq = exports.breakpoints = void 0;
/* eslint-disable sort-keys-fix/sort-keys-fix */
const facepaint_1 = __importDefault(require("facepaint"));
exports.breakpoints = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
};
exports.mq = facepaint_1.default(Object.values(exports.breakpoints).map(bp => `@media (min-width: ${bp}px)`), { overlap: true });
